var _rect, _path, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow51(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_25748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1188_25748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H43.9998V44H16V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1188_25748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 29.9999C17.9902 34.7539 20.7529 38.862 24.759 40.809L19.03 25.1121C18.3433 26.65 17.9889 28.3156 17.9902 29.9999ZM38.1081 29.3938C38.1081 27.9095 37.5749 26.8816 37.1176 26.0815C36.5088 25.0922 35.9384 24.2544 35.9384 23.2651C35.9384 22.1611 36.7755 21.1334 37.9549 21.1334C38.0082 21.1334 38.0587 21.14 38.1108 21.143C35.9738 19.1854 33.1271 17.9902 30.0003 17.9902C25.8045 17.9902 22.1131 20.143 19.9656 23.4036C20.2474 23.4121 20.5132 23.4178 20.7385 23.4178C21.9947 23.4178 23.9393 23.2654 23.9393 23.2654C24.5867 23.2272 24.663 24.1781 24.0165 24.2547C24.0165 24.2547 23.3657 24.3312 22.6417 24.3692L27.0153 37.3781L29.6438 29.4955L27.7724 24.3689C27.1257 24.331 26.513 24.2544 26.513 24.2544C25.8658 24.2165 25.9417 23.227 26.5889 23.2651C26.5889 23.2651 28.5723 23.4176 29.7524 23.4176C31.0084 23.4176 32.9531 23.2651 32.9531 23.2651C33.601 23.227 33.6771 24.1779 33.0302 24.2544C33.0302 24.2544 32.3782 24.331 31.6556 24.3689L35.9958 37.2794L37.1935 33.2763C37.7129 31.6151 38.1081 30.422 38.1081 29.3938Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2109 31.0509L26.6074 41.5217C27.7091 41.8463 28.8516 42.0112 30.0002 42.0112C31.3988 42.0112 32.74 41.7692 33.9884 41.3304C33.9549 41.278 33.9263 41.2226 33.903 41.1649L30.2109 31.0509ZM40.5385 24.2383C40.5902 24.6208 40.6194 25.0317 40.6194 25.4732C40.6194 26.692 40.3918 28.062 39.7062 29.7751L36.0377 40.3818C39.6082 38.2996 42.0098 34.4313 42.0098 30.0004C42.013 27.9864 41.5069 26.0042 40.5385 24.2383Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 16C22.2807 16 16 22.2802 16 29.9997C16 37.72 22.2804 44.0002 30.0001 44.0002C37.7194 44.0002 44.0009 37.7203 44.0009 29.9997C44.0007 22.2802 37.7194 16 30.0001 16ZM30.0001 43.3583C22.6346 43.3583 16.6419 37.3656 16.6419 29.9997C16.6419 22.6344 22.6344 16.6422 30.0001 16.6422C37.3654 16.6422 43.3576 22.6344 43.3576 29.9997C43.3576 37.3656 37.3651 43.3583 30.0001 43.3583Z",
    fill: "#00749A"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_25748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow51);
export default __webpack_public_path__ + "static/media/row-5-1.f683bae1f93cf47fc1b433679691180e.svg";
export { ForwardRef as ReactComponent };